<div class="pt-6" id="topContainer">
    <div class="p-2 ">
        <h3 [ngClass]="'text-'+globals.colorTheme">
            <i class=" material-icons">history</i>
            History
        </h3>
    </div>
</div>
<mat-divider></mat-divider>
<br>
<div #scrollable (scroll)="onScroll()">
    <mat-form-field class="full-width">
        <mat-label>Search Name</mat-label>
        <input matInput class="ta-quotes-search" placeholder="Search Name" id="nameField" [(ngModel)]="quoteSearch">
        <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <mat-form-field>
        <mat-label>Filter</mat-label>
        <mat-select (selectionChange)="onFilterChange($event)">
            <mat-option *ngFor="let filter of FilerValue;" [value]="filter.value">{{filter.viewValue}}</mat-option>
        </mat-select>
    </mat-form-field>




    <mat-accordion>
        <mat-expansion-panel *ngFor="let BookingData of filterQuote(BookingData)" expanded="false">
            <mat-expansion-panel-header [collapsedHeight]="'120px'" [expandedHeight]="'120px'"
                (click)="getItems(BookingData)"
                [ngClass]="'ta-quotes-' + BookingData.CustomerDescription.toLowerCase()">
                <mat-panel-title style="padding-right: 10px;">
                    <div style="margin-top: 20px;width:100%; padding: 0px;">
                        <div class="row" style="padding-top: 10px;">
                            <div class="col-10" style="padding-right: 0px;">
                                <small><span><strong>{{BookingData.BookingTimestamp | date:'MM/dd/yyyy' }}</strong>
                                    </span> - <span><strong>{{BookingData.TransactionType}}</strong> </span> - <span>
                                        <strong>{{BookingData.BookingNumber}}</strong></span> </small>
                            </div>
                            <div class="col-2" style="text-align: right;padding: 0px 0px 15px 0px;">
                                <small><strong *ngIf="BookingData.Status ==2" style="color:rgb(4, 158, 38)">
                                        Approved</strong> <strong *ngIf="BookingData.Status ==1"
                                        style="color:rgb(245, 170, 66)"> Pending</strong></small>

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-10" style="padding-right: 0px;">
                                <strong>{{BookingData.CustomerDescription}}</strong> <br> <small>{{BookingData.Count}}
                                    Items</small>
                            </div>
                            <div class="col-2" style="text-align: right;padding: 0px 0px 15px 0px;">
                                <strong>${{BookingData.TotalPrice | number}}</strong>
                            </div>
                        </div>

                    </div>



                </mat-panel-title>

            </mat-expansion-panel-header>


            <div>

                <div *ngFor="let item of BookingData.items">
                    <mat-divider></mat-divider>
                    <br>
                    <div class="row">
                        <div class="col-2">
                            <strong>Qty</strong>
                        </div>
                        <div class="col" style="text-align: left;">
                            {{item.Quantity}}
                        </div>
                        <div class="col" style="text-align: right;">
                            <strong>Amt</strong>
                        </div>
                        <div class="col" style="text-align: left;">
                            ${{item.Price|number}}
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-2">
                            <strong>Loc</strong>
                        </div>
                        <div class="col">
                            {{item.Location}}-{{item.ProductId}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <strong>Name</strong>
                        </div>
                        <div class="col">
                            {{item.ProductDescription}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <strong>Dates</strong>
                        </div>
                        <div class="col">
                            {{item.StartDate|date:'MM/dd/yyyy'}}-{{item.EndDate|date:'MM/dd/yyyy'}}
                        </div>
                    </div>
                    <br>
                </div>
                <div>
                    <div class="row">
                        <div class="col">
                            <strong>Total Amount:</strong>
                        </div>
                        <div class="col" style="text-align: right;padding-right: 30px;">
                            <strong>${{BookingData.TotalPrice | number}}</strong>
                        </div>
                        <br>
                    </div>
                    <br>
                    <br>
                </div>
                <div class="col" style="text-align: right;">
                    <!-- <button mat-button
                    class="mat-stroked-button-WhiteBackground-GreenText ta-history-View magin_5 color_green" 
                        (click)="showDialog(BookingData,BookingData,BookingData.items,'close',BookingData,BookingData,BookingData)">View</button> -->
                    <button *ngIf="isCopySupported(BookingData)" mat-button
                        class="mat-stroked-button-WhiteBackground-GreenText ta-history-Copy magin_5 color_green"
                        (click)="startCopyOrder(BookingData)">{{ getCopyButtonLabel(BookingData) }}</button>
                    <button mat-button [ngClass]="'ta-history-Print magin_5 text-white btn btn-'+globals.colorTheme"
                        (click)="onClickPrintButton(BookingData,BookingData.items)">Print</button>
                </div>
            </div>


        </mat-expansion-panel>
    </mat-accordion>
</div>